import { actions as loadingActions } from "../../components/loading/index";
import {
  notification
} from "antd";
import {history} from '../../extendedBrowserRouter'

export const loadCampusDashboardData = (campus,category) => {
  
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    dispatch(loadingActions.showLoading());
    // based on category

    firestore
      .collection("Dashboard")
      .doc(campus).collection(category && category.toUpperCase()).doc('DASHBOARDDATA')
      .get()
      // .collection("users")
      //   .get()
      .then(doc => {
        if(doc.exists){
          dispatch({
            type: "LOAD_CAMPUS_DASHBOARD_DATA",
            payload: doc.exists
              ? {
                  valid: true,
                  data: doc.data(),
                  skeltonLoading:false,
                }
              : { valid: false }
          });
          dispatch(loadingActions.hideLoading());
        }
        else{
          dispatch({
            type: "LOAD_CAMPUS_DASHBOARD_DATA",
            payload: { valid: false }
          });
          dispatch(loadingActions.hideLoading());
          notification.error({
            message: campus + ' Campus Not found. ',
            description:
              'Redirected to overall Dashboard'
          });
           history.push('/home/campusDashboard/ADMIN')
        }
      })
      .catch(function(error) {
        if(error.code!="permission-denied"){
          notification.error({
            message: '"YO"+Something went Wrong',
            duration:0,
            description:
              'Contact admin@vedic.dev '+error,
            onClick: () => {
              
            },
          });
        }
        
        dispatch(loadingActions.hideLoading());
      });
  };
};

export const loadStudentsList = () => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    loadStudentsListFromDB(dispatch, firestore,'student');
  };
};

export const loadFacultyList = () => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    loadStudentsListFromDB(dispatch, firestore,'faculty');
  };
};

function loadStudentsListFromDB(dispatch, firestore,type) {
  dispatch(loadingActions.showLoading());

  const dbRef = type && type=='student' ? firestore.collection("students").where('role', '==', 'STUDENT').where("profileCurrentStep",">=",3) :  firestore.collection("students")
  .where("role", "in", ["HOD", "PRINCIPAL", "FACULTY"]).where("profileCurrentStep",">=",3)

  dbRef
    .get()
    .then(doc => {
      dispatch({
        type: "LOAD_HOD_LIST",
        payload: !doc.empty
          ? {
            valid: true,
            data: doc.docs.map((doc, i) => {
              return { key: `${i}`, ...doc.data(), projectsDoneListArray:doc.data().projectsDoneListArray || [],workshopsAttendedArray:doc.data().workshopsAttendedArray||[],InternshipAttendedArray:doc.data().InternshipAttendedArray || [],certificationArray:doc.data().certificationArray||[],pubicationsArray:doc.data().pubicationsArray||[],conferenceAttendedArray:doc.data().conferenceAttendedArray||[],technicalSkillsArray:doc.data().technicalSkillsArray||[]};
            }),
            skeltonLoading: false,
          }
          : {
          valid: false,
            skeltonLoading: false
          }
      });
      dispatch(loadingActions.hideLoading());
    })
    .catch(function (error) {
      notification.error({
        message: 'Something went Wrong',
        duration: 0,
        description: 'Contact admin@vedic.dev ' + error,
        onClick: () => {
          
        },
      });
      dispatch(loadingActions.hideLoading());
    });
}